<script setup>
import {usePiniaStore} from "../store/pinia_store";
import {storeToRefs} from "pinia";
import {computed, watch} from "vue";
import moment from "moment";

const props = defineProps({
  langCode: {
    type: String,
  },
  cartUrl: {
    type: String,
  },
  productOverviewUrl: {
    type: String
  },
  myOrdersUrl: {
    type: String,
  },
  myListUrl: {
    type: String,
  },
  metadata: {
    type: Object,
  },
});

moment.locale(props.langCode);
const userStore = usePiniaStore();
const {cart, favorites, latest_order: latestOrder} = storeToRefs(userStore);

const newOrderText = window.Drupal.t('Place a new <strong>order</strong>');
const firstOrderText = window.Drupal.t('Place your first <strong>order</strong>');
const firstFavoriteText = window.Drupal.t('Favorite your first <strong>product</strong>');
const cartText = window.Drupal.t('Cart');
const completeOrderText = window.Drupal.t('Complete order');
const lastOrderText = window.Drupal.t('Last order');
const favoritesText = window.Drupal.t('My favorites');
const productsText = window.Drupal.t('products');

const cartQuantity = computed(() => cart.value.lines_quantity);
const formattedLatestOrderDate = computed(() => moment(latestOrder.value.created_at).format('D MMMM Y'));
const hasCartItems = computed(() => cart.value.lines_count > 0);
const hasFavoriteItems = computed(() => favorites.value.lines_count > 0);
const favoritesCount = computed(() => favorites.value.lines_count);

</script>

<template>
  <div class="vue-homepage-buttons col-12" v-if="!userStore.isLoading">
    <div class="btn-row">
      <a v-if="hasCartItems" :href="cartUrl" class="btn btn-complete-order">
        <div class="btn-icon">
          <span class="icon-cart"></span>
          <span class="badge">{{ cartQuantity }}</span>
        </div>
        <div class="btn-text">
          {{ cartText }}
          <span class="meta">{{ completeOrderText }}</span>
        </div>
      </a>
      <a v-if="!hasCartItems" :href="productOverviewUrl" class="btn">
        <div class="btn-icon">
          <span class="icon-cart"></span>
        </div>
        <div class="btn-text" v-html="newOrderText">
        </div>
      </a>
      <a v-if="latestOrder" :href="myOrdersUrl" class="btn btn-last-order">
        <div class="btn-icon">
          <dentaid-last-order-icon></dentaid-last-order-icon>
        </div>
        <div class="btn-text">
          {{ lastOrderText }}
          <span class="meta">{{ formattedLatestOrderDate }}</span>
        </div>
      </a>
      <a v-if="!latestOrder" :href="productOverviewUrl" class="btn btn-first-order">
        <div class="btn-icon">
          <dentaid-last-order-icon></dentaid-last-order-icon>
        </div>
        <div class="btn-text" v-html="firstOrderText">
        </div>
      </a>

      <a v-if="hasFavoriteItems" :href="myListUrl" class="btn btn-favorites">
        <div class="btn-icon">
          <dentaid-favorite-icon></dentaid-favorite-icon>
        </div>
        <div class="btn-text">
          {{ favoritesText }}
          <span class="meta">{{ favoritesCount }} {{ productsText }}</span>
        </div>
      </a>
      <a v-if="!hasFavoriteItems" :href="productOverviewUrl" class="btn btn-favorites">
        <div class="btn-icon">
          <dentaid-favorite-icon></dentaid-favorite-icon>
        </div>
        <div class="btn-text" v-html="firstFavoriteText">
        </div>
      </a>
    </div>
  </div>
</template>
